<template>
  <ionic-vue-page
    v-bind:title="screenTitle"
    v-bind:showMenuButton="false"
    v-bind:refresh="refresh"
  >
    <error-message v-if="error" v-bind:message="error"></error-message>

    <skeleton-list v-if="loadingPaymentData"></skeleton-list>

    <div
      v-if="!loadingPaymentData && payments.length == 0"
      class="ion-margin"
      style="font-weight: bold;"
    >
      Sorry, you don't have any earnings for this month yet!
    </div>

    <ion-list
      v-else
      v-for="(date, index) in payments"
      v-bind:key="index"
      lines="full"
    >
      <ion-item color="primary">
        <span class="h-f-b">{{ date.label }}</span>
      </ion-item>
      <pay-breakdown
        v-for="(service, index) in date.services"
        :key="index"
        :products="products"
        :service="service"
      ></pay-breakdown>
    </ion-list>
  </ionic-vue-page>
</template>

<script>
import paymentsApiService from "./../services/PaymentsApi";
import productsApiService from "./../services/ProductsApi";
import moment from "moment";
import SkeletonList from "./../components/SkeletonList";
import mixins from "./../mixins/mixins";
import PayBreakdown from "./../components/PayBreakdown";

const paramDateFormat = "YYYY-MM-DD";
const displayDateFormat = "dddd Do MMM YY";

export default {
  name: "DailyEarnings",
  mixins: [mixins],
  components: {
    "skeleton-list": SkeletonList,
    PayBreakdown,
  },
  data() {
    return {
      screenTitle: "Daily Earnings",
      startDate: "",
      endDate: "",
      payments: [],
      products: [],
      error: false,
      loadingPaymentData: false,
    };
  },

  computed: {
    formattedPayments() {
      return Object.entries(this.payments).map((payment) => {
        //format the object
        return {
          label: this.products[payment[0]],
          total: payment[0] != "total" ? payment[1].total : payment[1],
          breakdown: payment[0] != "total" ? payment[1] : {},
        };
      });
    },
  },

  async mounted() {
    const loading = await this.$ionic.loadingController.create({
      message: "Loading daily earnings...",
    });
    loading.present();
    this.loadingPaymentData = true;

    try {
      const screenData = await this.getData();

      this.products = screenData[0];
      this.payments = this.handlePaymentsData(screenData[1]);
    } catch (error) {
      this.error = error;
    } finally {
      loading.dismiss();
      this.loadingPaymentData = false;
    }
  },

  methods: {
    handlePaymentsData(data) {
      let returnData = [];

      returnData = Object.entries(data).map((payment) => {
        return {
          label: moment(payment[0]).format(displayDateFormat),
          services: Object.entries(payment[1])
            .map((payment) => {
              return {
                label: this.products[payment[0]],
                total: payment[0] != "total" ? payment[1].total : payment[1],
                breakdown: payment[0] != "total" ? payment[1] : {},
              };
            })
            .filter((service) => {
              return (
                Object.keys(service.breakdown).length > 1 ||
                service.label == "Total"
              );
            }),
        };
      });

      return returnData;
    },

    async refresh(event) {
      this.payments = [];
      this.loadingPaymentData = true;

      try {
        const screenData = await this.getData();

        this.products = screenData[0];
        this.payments = this.handlePaymentsData(screenData[1]);
      } catch (error) {
        this.error = error;
      } finally {
        event.target.complete();
        this.loadingPaymentData = false;
      }
    },

    async getData() {
      this.startDate = this.$route.params.startDate;
      this.endDate = this.$route.params.endDate;

      if (moment(this.endDate).isAfter()) {
        this.endDate = moment().format(paramDateFormat);
      }

      const productsCall = productsApiService.get();
      const paymentsCall = paymentsApiService.getDaily(
        this.startDate,
        this.endDate
      );

      return await Promise.all([productsCall, paymentsCall]);
    },
  },
};
</script>
